import { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE } from "../config/api";
import "./OneEyedCoconutDetails.css";

const CATEGORY_KEY = "one-eyed-coconut";
const DEFAULT_HEADING = "Ekakshi / One-Eyed Coconut";

function OneEyedCoconutDetails() {
  const [categoryContent, setCategoryContent] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchCategoryContent = async () => {
      try {
        const response = await axios.get(`${API_BASE}/category-content/${CATEGORY_KEY}`);

        if (isMounted) {
          setCategoryContent(response.data || null);
        }
      } catch (error) {
        console.error("Failed to load one-eyed coconut details:", error);

        if (isMounted) {
          setCategoryContent(null);
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    fetchCategoryContent();

    return () => {
      isMounted = false;
    };
  }, []);

  const pageHeading =
    String(categoryContent?.pageHeading || "").trim() || DEFAULT_HEADING;
  const mainDescription = String(categoryContent?.mainDescription || "").trim();
  const note = String(categoryContent?.note || "").trim();

  return (
    <div className="one-eyed-details-page">
      <section className="one-eyed-details-card">
        <h1>{pageHeading}</h1>

        {isLoading ? (
          <p className="one-eyed-details-loading">Loading content...</p>
        ) : (
          <>
            {mainDescription ? (
              <p className="one-eyed-details-description">{mainDescription}</p>
            ) : null}

            {note ? (
              <div className="one-eyed-details-note">
                <strong>Note:</strong>
                <p>{note}</p>
              </div>
            ) : null}
          </>
        )}
      </section>
    </div>
  );
}

export default OneEyedCoconutDetails;
